import { Box, Typography, Button, Chip, styled } from '@material-ui/core';

export const StyledCard = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  width: 300,
  borderRadius: 12,
  overflow: 'hidden',
  background: 'white',
  fontFamily: 'Open Sans, sans-serif',
});

export const ImageContainer = styled(Box)({
  position: 'relative',
  overflow: 'hidden',
  height: 200,
  flexShrink: 0,
});

export const CardImage = styled('img')({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
});

export const CardTitleWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
});

export const CardTitle = styled(Typography)(({ theme }) => ({
  margin: 0,
  fontSize: '20px',
  fontWeight: 700,
  letterSpacing: '0.15px',
  color: theme.palette.primary.main,
  lineHeight: '24px',
  fontFamily: '"Red Hat Display", sans-serif',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
}));

export const CardSubtitle = styled(Typography)(({ theme }) => ({
  margin: 0,
  fontSize: '12px',
  fontWeight: 400,
  letterSpacing: '0.2px',
  color: theme.palette.text.tertiary,
  lineHeight: '16px',
  fontFamily: '"Open Sans", sans-serif',
}));

export const CardDescription = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: '16px',
  lineHeight: '28px',
  letterSpacing: '0.44px',
  fontFamily: '"Open Sans", sans-serif',
  margin: 0,
  WebkitLineClamp: 4,
  overflow: 'hidden',
  WebkitBoxOrient: 'vertical',
  display: '-webkit-box',
  flexGrow: 1,
}));

export const CardBody = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  padding: '16px 24px',
  gap: 8,
});

export const CardActions = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  paddingLeft: 16,
  paddingBottom: 8,
});

export const ActionButton = styled(Button)(({ theme }) => ({
  borderRadius: 6,
  color: `${theme.palette.primary.main} !important`,
}));

export const StyledChip = styled(Chip)({
  height: 28,
  fontSize: 14,
  lineHeight: '24px',
  margin: '0 !important',
});

export const BadgeWrapper = styled(Box)({
  position: 'absolute',
  top: 12,
  right: 12,
});

export const StatusBadge = styled(Box)(({ theme }) => ({
  alignItems: 'center',
  padding: '4px 12px',
  borderRadius: 6,
  fontSize: 12,
  fontWeight: 600,
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  textTransform: 'capitalize',
}));
